import React from "react";
import "../css/Home2.css";

const Home2 = () => {
  return (
    <div className="home2">

      {/* ---------- HERO (Kept as requested) ---------- */}
      <section className="home2-hero">
        <img
          src="https://images.pexels.com/photos/7319816/pexels-photo-7319816.jpeg?auto=compress&cs=tinysrgb&w=1800&q=80"
          alt="Athlete"
          className="home2-banner"
        />
        <div className="home2-overlay">
          <h1>UNLEASH YOUR FORM</h1>
          <p>Minimal design. Maximum performance.</p>
          <a href="/workout" className="hero-btn">Start Training</a>
        </div>
      </section>


      {/* ---------- SECTION 1 — SPLIT STORY PANEL ---------- */}
      <section className="ethos-split">
        <div className="split-left">
          <h2>Movement. Mindset.<br />Modern Training.</h2>
          <p>
            FLEXOR focuses on precision-based execution, elevated performance,
            and long-term durability — no shortcuts, just mastery.
          </p>
        </div>

        <div className="split-right">
          <img 
            src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1500&q=80"
            alt="Training focus"
          />
        </div>
      </section>


      {/* ---------- SECTION 2 — FEATURE ROW ---------- */}
      <section className="ethos-features">
        <div className="feature">
          <h3>◎ Precision Coaching</h3>
          <p>Technique-first training for maximal output with minimal risk.</p>
        </div>

        <div className="feature">
          <h3>◎ Smart Programming</h3>
          <p>Periodized schedules engineered for consistent progress.</p>
        </div>

        <div className="feature">
          <h3>◎ Human Performance</h3>
          <p>Strength, conditioning & mobility crafted for real-world power.</p>
        </div>
      </section>


      {/* ---------- SECTION 3 — ASYMMETRIC PANELS ---------- */}
      <section className="ethos-panels">

        <div className="panel panel-a">
          <h2>Form Drives Force</h2>
          <p>Movement efficiency creates undeniable strength.</p>
        </div>

        <div className="panel panel-b">
          <img 
            src="https://images.unsplash.com/photo-1602611000981-f9e33f0d1f39?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Force training"
          />
        </div>

        <div className="panel panel-c">
          <img 
            src="https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Strength culture"
          />
        </div>

        <div className="panel panel-d">
          <h2>Strength in Stillness</h2>
          <p>Athletes who master calmness master performance.</p>
        </div>

      </section>


      {/* ---------- SECTION 4 — MARQUEE STRIP ---------- */}
      <section className="ethos-marquee">
        <div className="marquee-track">
          <span> FLEXOR TRAINING ✦ CONTROL ✦ STRENGTH ✦ BALANCE ✦ </span>
          <span> FLEXOR TRAINING ✦ CONTROL ✦ STRENGTH ✦ BALANCE ✦ </span>
        </div>
      </section>


      {/* ---------- SECTION 5 — PHILOSOPHY ---------- */}
      <section className="ethos-philosophy">
        <h2>The FLEXOR Philosophy</h2>
        <p>
          Training is an evolving craft — a blend of intelligence, discipline,
          and execution. FLEXOR creates athletes built on intention, not ego.
          Every rep is a step toward mastery.
        </p>

        <a href="/about" className="philosophy-btn">Learn More</a>
      </section>


      {/* =================== NEW SECTION A =================== */}
      {/* ---------- MODULAR TRAINING BLOCKS ---------- */}
      <section className="ethos-modules">
        <div className="module">
          <h3>STRENGTH</h3>
          <p>Build controlled power through structured resistance training.</p>
        </div>

        <div className="module">
          <h3>DISCIPLINE</h3>
          <p>Consistency and intention form the backbone of long-term progress.</p>
        </div>

        <div className="module">
          <h3>PRECISION</h3>
          <p>Every rep executed with accuracy for maximum return.</p>
        </div>
      </section>


      {/* =================== NEW SECTION B =================== */}
      {/* ------- ATHLETE ASCENT TIMELINE ------- */}
      <section className="ethos-timeline">
        <h2 className="timeline-title">The Athlete’s Ascent</h2>

        <div className="timeline">
          <div className="step">
            <span className="dot"></span>
            <div>
              <h4>Foundation</h4>
              <p>Master the basics. Build control, stability, and mobility.</p>
            </div>
          </div>

          <div className="step">
            <span className="dot"></span>
            <div>
              <h4>Development</h4>
              <p>Introduce complexity. Grow strength through structured progressions.</p>
            </div>
          </div>

          <div className="step">
            <span className="dot"></span>
            <div>
              <h4>Performance</h4>
              <p>Unlock peak capability — speed, strength, and endurance aligned.</p>
            </div>
          </div>
        </div>
      </section>


      {/* =================== NEW SECTION C =================== */}
      {/* ---------- BLACK FRAME SHOWCASE ---------- */}
      <section className="ethos-frame-showcase">
        <div className="frame-image"></div>

        <div className="frame-text">
          <h2>Where Movement Becomes Art</h2>
          <p>
            Training isn't just physical — it's a creative discipline. 
            FLEXOR blends style with science to craft athletes with presence, power, and confidence.
          </p>

          <a href="/gallery" className="frame-btn">View Gallery</a>
        </div>
      </section>

    </div>
  );
};

export default Home2;
